import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static classes = ["selected", "unselected"]

  connect() {
    // Initialization if needed
  }

  // Handle Step 1: Radio Selection (Industry)
  selectRadio(event) {
    const selectedItem = event.currentTarget
    const radio = selectedItem.querySelector('input[type="radio"]')
    
    if (radio) {
      radio.checked = true
      
      // Update visual states for all items in this controller's scope
      this.itemTargets.forEach(item => {
        const isCurrent = item === selectedItem
        this.updateItemState(item, isCurrent)
      })
    }
  }

  // Handle Step 2: Checkbox Toggle (Modules)
  toggleCheckbox(event) {
    const selectedItem = event.currentTarget
    const checkbox = selectedItem.querySelector('input[type="checkbox"]')
    
    // If the click was not directly on the checkbox, toggle it
    if (event.target !== checkbox) {
      checkbox.checked = !checkbox.checked
    }
    
    this.updateItemState(selectedItem, checkbox.checked)
  }

  updateItemState(item, isSelected) {
    // Specific classes for Step 1 & 2 redesign
    const selectedClasses = ["border-emerald-500", "bg-emerald-50/50", "shadow-lg", "shadow-emerald-100", "ring-4", "ring-emerald-50"]
    const unselectedClasses = ["border-gray-100", "bg-white"]
    
    // Icon/Check classes
    const iconContainer = item.querySelector('.icon-container')
    const checkCircle = item.querySelector('.check-circle')
    const checkMark = item.querySelector('.check-mark')
    const title = item.querySelector('.item-title')

    if (isSelected) {
      item.classList.add(...selectedClasses)
      item.classList.remove(...unselectedClasses)
      
      if (iconContainer) {
        iconContainer.classList.add("bg-emerald-600", "text-white", "shadow-lg", "shadow-emerald-200")
        iconContainer.classList.remove("bg-gray-100", "text-gray-500")
      }
      
      if (checkCircle) {
        checkCircle.classList.add("bg-emerald-600", "border-emerald-600")
        checkCircle.classList.remove("bg-white", "border-gray-200")
      }
      
      if (checkMark) {
        checkMark.classList.add("scale-100", "opacity-100")
        checkMark.classList.remove("scale-0", "opacity-0")
      }

      if (title) {
        title.classList.add("text-emerald-700")
        title.classList.remove("text-gray-900")
      }
    } else {
      item.classList.remove(...selectedClasses)
      item.classList.add(...unselectedClasses)
      
      if (iconContainer) {
        iconContainer.classList.remove("bg-emerald-600", "text-white", "shadow-lg", "shadow-emerald-200")
        iconContainer.classList.add("bg-gray-100", "text-gray-500")
      }
      
      if (checkCircle) {
        checkCircle.classList.remove("bg-emerald-600", "border-emerald-600")
        checkCircle.classList.add("bg-white", "border-gray-200")
      }
      
      if (checkMark) {
        checkMark.classList.remove("scale-100", "opacity-100")
        checkMark.classList.add("scale-0", "opacity-0")
      }

      if (title) {
        title.classList.remove("text-emerald-700")
        title.classList.add("text-gray-900")
      }
    }
  }
}
